
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"22.5","cy":"22.5","r":"21.5","fill":"currentColor","stroke":"currentColor","stroke-width":"2"}}),_c('path',{attrs:{"d":"M24.176 28.2L25 17.706V9h-4v8.706l.902 10.494h2.274zM25 37v-4h-4v4h4z","fill":"#FFF","fill-rule":"nonzero"}})])])
          )
        }
      }
    